module.exports = __webpack_public_path__ + "static/img/AZ.bd4b4417.svg";